module.exports = __webpack_public_path__ + "img/logout.9b3063a8.png";